type JsonLdPayload = Record<string, unknown>;

export const buildHomepageJsonLd = (origin: string): string => {
  const organization: JsonLdPayload = {
    '@type': 'Organization',
    name: 'CapQuest',
    url: origin,
    logo: `${origin}/favicon.ico`,
    sameAs: ['https://www.linkedin.com/company/capquest', 'https://x.com/capquest_io'],
  };

  const website: JsonLdPayload = {
    '@type': 'WebSite',
    name: 'CapQuest',
    url: origin,
    inLanguage: 'en',
  };

  const softwareApplication: JsonLdPayload = {
    '@type': 'SoftwareApplication',
    name: 'CapQuest',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    url: origin,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    description:
      'CapQuest helps teams manage equity, cap tables, stakeholder communications, and investor relations.',
  };

  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [organization, website, softwareApplication],
  });
};
